import React, { useState, useEffect, useContext } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { GoogleButton } from 'react-google-button';
import { UserAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { AppContextisChecked } from '../context/AppContextisChecked';
import ChainedLM0 from '../assets/ChainedLM0.jpeg';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal({ openModal, setOpenModal }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setOpenModal(false)
  }
  const { googleSignIn, user, loading, authError, sessionTerminated } = UserAuth();
  const { auth, setAuth } = useContext(AppContextisChecked);
  const navigate = useNavigate();
  const [localError, setLocalError] = useState(null);
  // console.log("Signin component rendering with user:", user);
  // console.log("Auth loading state:", loading);
  // console.log("Auth error:", authError);
  // console.log("Session terminated:", sessionTerminated);
  const handleGoogleSignIn = async () => {
    try {
      // console.log("Google Sign-in button clicked");
      setLocalError(null); // Clear any previous errors
      await googleSignIn();
      setAuth(true)
      // console.log("googleSignIn function completed");
    } catch (error) {
      // console.error("Error in handleGoogleSignIn:", error);
      setAuth(false)
      // setLocalError(error.message || "Authentication failed");
    }
  };

  // // Navigation after login
  // useEffect(() => {
  //   console.log("Signin navigation useEffect triggered. User:", user);
  //   if (user) {
  //     console.log("User exists, navigating to home");
  //     navigate('/');
  //   }
  // }, [user, navigate]);
  useEffect(() => {
    if (openModal) {
      setOpen(true)
    }
  }, [openModal])

  // Debug logging
  useEffect(() => {
    // console.log("Debug useEffect triggered");
    if (user) {
      setAuth(true)
      setOpen(false)
      // console.log("User authenticated:", {
      //   uid: user.uid,
      //   email: user.email,
      //   displayName: user.displayName,
      //   providerId: user.providerId,
      //   isAnonymous: user.isAnonymous,
      //   emailVerified: user.emailVerified,
      //   metadata: user.metadata
      // });
    } else {
      setAuth(false)
      setOpen(true)
      // console.log("No authenticated user available");
    }
  }, [user]);

  return (

    <div style={{ width: '50vw !important' }}>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      // style={{width: '68vw !important'}}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '30.5vw !important',
          height: '82vh !important',
          borderRadius: '16px',
          boxShadow: '0 10px 50px rgba(0, 0, 0, 0.25)',
          padding: '32px 24px',
          background: 'linear-gradient(145deg, #ffffff, #f5f7fa)',
          border: '1px solid rgba(209, 213, 219, 0.3)',
          outline: 'none',
          transition: 'all 0.3s ease-in-out'
        }}>

          <div style={{ textAlign: 'center', marginTop: '10%', marginBottom: '10%' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
              <img src={ChainedLM0} style={{ height: '64px', marginLeft: '10px', borderRadius: '15px' }} />
              <div style={{ fontFamily: 'sans-serif', display: 'inline-block', padding: '0.675rem 1rem', backgroundColor: 'rgb(17 24, 39)', color: 'white', borderRadius: '9999px', fontSize: '0.875rem', fontWeight: 600, marginBottom: '-0.2em' }}>
                Powered by ChainedLLM
              </div>
            </div>
            <h1 style={{ fontSize: '28px', fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif', color: 'rgb(17 24, 39)', marginBottom: '1rem', letterSpacing: '-0.025em', fontWeight: 200, width: '78%', marginLeft: 'auto', marginRight: 'auto' }}>
              Your AI Powered Content Research Assistant
            </h1>
            <p style={{ fontFamily: 'sans-serif', fontSize: '18px', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625 }}>
              Let your AI Agent take over!
            </p>
          </div>

          {/* <h2 style={{
            fontFamily: 'sans-serif',
            textAlign: 'center',
            fontSize: '28px',
            fontWeight: '700',
            marginBottom: '24px',
            background: 'linear-gradient(90deg,rgb(126, 126, 126),rgb(0, 0, 0))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-0.5px'
          }}>Please, Sign in
          </h2> */}

          <div style={{ margin: 'auto', paddingTop: '12px', paddingBottom: '16px' }}>
            {sessionTerminated && (
              <div style={{
                background: 'rgba(254, 240, 199, 0.5)',
                borderLeft: '4px solid #f59e0b',
                color: '#92400e',
                padding: '12px 16px',
                marginBottom: '20px',
                borderRadius: '0 8px 8px 0',
                boxShadow: '0 2px 10px rgba(251, 211, 141, 0.3)'
              }} role="alert">
                <p style={{ fontWeight: '600', marginBottom: '4px' }}>Session Terminated</p>
                <p style={{ fontSize: '13px', lineHeight: '1.4' }}>Your session was ended because authentication cookies were cleared. Please sign in again.</p>
              </div>
            )}

            <div style={{
              filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))',
              transition: 'all 0.2s ease'
            }}>
              <GoogleButton style={{ backgroundColor: 'white', color: 'black', borderRadius: '0px', width: '100%' }} onClick={handleGoogleSignIn} disabled={loading} />
            </div>

            {loading && <p style={{
              textAlign: 'center',
              marginTop: '16px',
              color: '#6b7280',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}>
              <span style={{
                display: 'inline-block',
                width: '18px',
                height: '18px',
                border: '3px solid rgba(59, 130, 246, 0.2)',
                borderTopColor: 'rgba(59, 130, 246, 0.8)',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></span>
              Loading... please wait...
            </p>}

            {localError && <p style={{
              textAlign: 'center',
              marginTop: '12px',
              color: '#ef4444',
              fontSize: '14px',
              padding: '8px 16px',
              background: 'rgba(254, 226, 226, 0.5)',
              borderRadius: '8px'
            }}>{localError}</p>}

            {authError && <p style={{
              textAlign: 'center',
              marginTop: '12px',
              color: '#ef4444',
              fontSize: '14px',
              padding: '8px 16px',
              background: 'rgba(254, 226, 226, 0.5)',
              borderRadius: '8px'
            }}>Auth error: {authError.message}</p>}

            {/* <div style={{
              marginTop: '24px',
              padding: '12px',
              borderTop: '1px solid rgba(209, 213, 219, 0.3)',
              textAlign: 'center'
            }}>
              <p style={{
                fontSize: '14px',
                color: '#6b7280',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}>
                <span style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: user ? '#10b981' : '#6b7280',
                  boxShadow: user ? '0 0 10px rgba(16, 185, 129, 0.5)' : 'none',
                  display: 'inline-block'
                }}></span>
                Auth Status: {loading ? "Loading..." : user ? "Signed In" : "Not Signed In"}
              </p>
            </div> */}

            {/* Trust information section */}
            <div style={{
              marginTop: '24px',
              padding: '16px',
              borderTop: '1px solid rgba(209, 213, 219, 0.3)',
              borderBottom: '1px solid rgba(209, 213, 219, 0.3)',
              textAlign: 'left'
            }}>
              <p style={{
                fontSize: '14.5px',
                color: '#4b5563',
                marginBottom: '8px',
                fontFamily: 'sans-serif',
                fontWeight: '500'
              }}>
                <span style={{ fontWeight: '600', color: '#111827' }}>Why ChainedLLM is secure:</span>
              </p>
              <ul style={{
                fontSize: '13.5px',
                color: '#6b7280',
                listStyleType: 'none',
                padding: '0',
                margin: '0',
                lineHeight: '1.5'
              }}>
                <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '6px' }}>
                  <span style={{ color: '#10b981', marginRight: '6px' }}>✓</span>
                  <span>Your data is never stored in any database.</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '6px' }}>
                  <span style={{ color: '#10b981', marginRight: '6px' }}>✓</span>
                  <span>We use Google authentication for enhanced security</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '6px' }}>
                  <span style={{ color: '#10b981', marginRight: '6px' }}>✓</span>
                  <span>AI Agent never sees your log in credentials</span>
                </li>
              </ul>
            </div>

            {/* Testimonial section */}
            <div style={{
              marginTop: '16px',
              padding: '8px 4px',
              borderRadius: '8px',
              background: 'rgba(243, 244, 246, 0.5)',
              textAlign: 'center'
            }}>
              <p style={{
                fontSize: '12px',
                fontStyle: 'italic',
                color: '#6b7280',
                margin: '0 0 4px 0'
              }}>
                "ChainedLLM has revolutionized how our team conducts research, saving us countless hours."
              </p>
              <p style={{
                fontSize: '11px',
                color: '#4b5563',
                fontWeight: '600',
                margin: '0'
              }}>
                — Sarah M., Content Strategist
              </p>
            </div>

            {/* Privacy note */}
            <p style={{
              fontSize: '11px',
              color: '#9ca3af',
              textAlign: 'center',
              marginTop: '16px',
              fontFamily: 'sans-serif'
            }}>
              By signing in, you agree to our <span style={{ textDecoration: 'underline' }}>Terms of Service</span> and <span style={{ textDecoration: 'underline' }}>Privacy Policy</span>
            </p>
          </div>
        </Box>
      </Modal>
    </div>
  );
}